import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=a74dac56&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=a74dac56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74dac56",
  null
  
)

export default component.exports